import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { FIRST_NAME_SCHEMA_FIELD_NAME } from "./FirstNameFormField.schema";

/**
 * FirstNameFormField facilitates the input of a first name.
 */

export const FirstNameFormField = (props) => {
  const {
    componentProps,
    disabled,
    label = i18n("FirstNameFormField__LABEL"),
    name = FIRST_NAME_SCHEMA_FIELD_NAME,
  } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("FirstNameFormField__ARIA"),
        ...componentProps,
      },
      disabled,
      label,
      name,
    };
  }
};

export const firstNameFormFieldPropTypes = {
  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Content above the form field, used to identify the form field. */
  label: PropTypes.string,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

FirstNameFormField.propTypes = firstNameFormFieldPropTypes;
